import React from "react";
import Blog from "./Blog";
import img1 from "../../assets/blogImage1.jpeg";
import img2 from "../../assets/blogImage2.jpeg";

const data1 = [
  {
    image: img1,
    date: "20 October 2023 | Brett Auton, 6 min read",
    heading: "Using EdTech to Close Education Gaps",
    desc: "Famous French sociologist Emile Durkheim once said, “Education is the only image and reflection of society”. In other words, the inequalities we see in broader society filter",
  },
  {
    date: "19 September 2023 | Rob Cheesman, 5 min read",
    heading:
      "How Manufacturers are Using Technology to Meet Old and New Challenges",
    desc: "Manufacturing is a vital sector of the Australian economy, contributing to 5.4% of GDP1 and employing almost 900,000 people in 2022.2 Though in July of this year Australian",
  },
  {
    date: "5 September 2023 | Craig Somerville, 4 min read",
    heading: "How CIOs can Navigate the Evolving World of AI",
    desc: "Even in a sector where rapid change is the norm, the rate at which artificial intelligence (AI) is evolving has taken many IT professionals by surprise.",
  },
];

const data2 = [
  {
    date: "11 October 2023 | Doug Townley & Brett Auton, 5 min read",
    heading:
      "How AI technology is Unlocking New Opportunities Within the Education Sector",
    desc: "In the constantly evolving education sector, the recent rapid increase in artificial intelligence (AI) technology is creating both opportunities and challenges for staff and students. It’s..",
  },
  {
    date: "10 October 2023 | Rob Cheesman, 5 min read",
    heading: "Transforming the Culture of the Factory Floor with QAD Redzone",
    desc: "Last month, I introduced QAD Redzone, recently launched in Australia. I haven’t been this excited about the possibilities for manufacturing in a while. And here’s why.",
  },
  {
    date: "22 September 2023 | Brett Auton, 6 min read",
    heading:
      "Applying Student-Centred Learning: Utilising the Microsoft K-12 Education Transformation Framework",
    desc: "Working in and with educational institutions over three decades, I’ve watched technology permeate all aspects and functions in schools. Today, it can be used to not only",
  },
  {
    image: img2,
    date: "28 August 2023 | Greg Mace, 5 min read",
    heading: "A Culture of Possibility: Levelling Up",
    desc: "The breadth of GogiBus's end-to-end capability has significantly enhanced over the last 12 months, with business units seeing more significant collaboration",
  },
];

const BlogSections = () => {
  return (
    <div className="my-[100px] mx-auto w-full px-3 lg:w-[80%] flex flex-col md:flex-row gap-5">
      <div className="flex flex-col md:w-[50%] gap-[33px]  justify-start items-center">
        {data1.map((item, index) => {
          return (
            <Blog
              index={index}
              heading={item.heading}
              date={item.date}
              description={item.desc}
              image={item?.image}
            />
          );
        })}
      </div>
      <div className="flex flex-col md:w-[50%] gap-[100px] justify-start items-center">
        {data2.map((item, index) => {
          return (
            <Blog
              index={index}
              heading={item.heading}
              date={item.date}
              description={item.desc}
              image={item?.image}
            />
          );
        })}
      </div>
    </div>
  );
};

export default BlogSections;
